import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import { LineChart } from '@mui/x-charts/LineChart';
import dayjs from "dayjs";
import { main_server } from "../../constants";

const SpeedSlider = styled(Slider)(({ theme }) => ({
    color: 'white',
    height: 10,
    width: '70%',
    marginLeft: '30px',
    padding: '13px 0',
    '& .MuiSlider-thumb': {
        display: 'none'
    },
'& .MuiSlider-track': {
  boxShadow: 'inset 0px 0px 4px -2px #000',
  backgroundImage: 'linear-gradient(90deg,hsl(123,90%,55%),hsl(63,90%,55%) 40%,hsl(3,90%,55%) 100%)'
},
  }));

const Stats = (props) => {

  const [stats, setStats] = useState([]);
  const [lstats, setLStats] = useState([]);
  const [axis, setAxis] = useState([]);

    const marks = [
        {
          value: 1,
          label: '0',
        },
        {
          value: 25,
          label: '25%',
        },
        {
          value: 50,
          label: '50%',
        },
        {
          value: 75,
          label: '75%',
        },
        {
            value: 100,
            label: '100%',
          },
      ];
      
      function valuetext(value: number) {
        return `${value}MN/s`;
      }

      const getLast7DaysData = (data) => {
        const today = dayjs().startOf("day"); // Start of today
        var last7Days = [...Array.from({ length: 6 }, (_, i) =>
          today.subtract(6 - i, "day")
        ), today]; // Last 7 days including today
        console.log(last7Days);
        

        console.log('L7D:');
        console.log(last7Days);
      
        return last7Days.map((date) => {
          // Filter entries for this specific day
          const entriesForDay = data.filter((item) => {
            const currentDate = new Date(item.start);
            const compareDate = new Date(date.toISOString());
            return currentDate.getFullYear() === compareDate.getFullYear() && currentDate.getMonth() === compareDate.getMonth() && currentDate.getDate() === compareDate.getDate();
          }
          );
          console.log(entriesForDay);
      
          // Calculate total amount for the day
          const totalAmount = entriesForDay.filter((val) => val.engine === 0).reduce(
            (sum, item) => sum + item.time * item.price,
            0
          );

          const LCAmount = entriesForDay.filter((val) => val.engine === 1).reduce(
            (sum, item) => sum + item.time * item.price,
            0
          );
          return {
            day: date.format("dddd"), // e.g., "Wednesday"
            sf: totalAmount / 100000, // Convert milliseconds to seconds if needed
            lc: LCAmount
          };
      
        });
      };

      async function getStats() {
          const games = await fetch(main_server + "stats", {
                   method: "GET",
                   headers: {
                     "Content-Type": "text/plain",
                     Authorization: "Bearer " + localStorage.getItem("chesscloud-token"),
                   },
                 });
           if (games.status === 200) {
         try {
           const data = await games.json();
           if (data === null) {
               console.log('DATA IS NULL');
               return;
           }
           setStats(data);
          } catch (e) {
            console.log(e);
          }
        } else {

        }
      }

      useEffect(() => {
        getStats();
      }, []);

      const valueFormatter = (value: number | null) => `$${value?.toFixed(2)}`;

    return (
        <div>
                        <SpeedSlider
        defaultValue={props.size / (props.plan === 0 ? 100 : props.plan === 1 ? 10000 : props.plan === 2 ? 100000 : props.size)}
        getAriaValueText={valuetext}
        disabled={true}
        marks={marks}
        sx={{
          "&": {
          transform: props.width < 800 ? 'scale(0.7)' : 'scale(1)',
          marginLeft: props.width < 800 ? '-12vw' : '0'
        },
          '& .MuiSlider-markLabel': {
       color: props.dark ? 'white' : 'black',
     }}}
      />
      <p className={`mt-2 text-sm font-medium leading-12 ml-7 ${!props.dark ? 'text-gray-500' : 'text-gray-200'}`}>Coins Usage:</p>
      <LineChart
      dataset={getLast7DaysData(stats)}
      xAxis={[
        {
          scaleType: "band",
          dataKey: "day",
          valueFormatter: (day) => day,
        },
      ]}
      series={[
        {
          dataKey: "sf",
          label: "Stockfish 17",
          id: "sf",
          valueFormatter,
        },
        {
          dataKey: "lc",
          label: "Leela Chess Zero",
          id: "lcz",
          valueFormatter,
        }
      ]}
      sx={{
        "&": {
          transform: props.width < 800 ? 'scale(0.6)' : 'scale(1)',
          marginRight: props.width < 800 ? '40%' : '0'
        },
        "& .MuiChartsLegend-series-lcz text": {
          stroke: props.dark? "white" : "black",
          border: 'none'
        },
        "& .MuiChartsLegend-series-sf text": {
          stroke: props.dark? "white" : "black",
          border: 'none'
        },
        "& .MuiChartsAxis-root": {
          stroke: props.dark? "white" : "black"
        },
        //change left yAxis label styles
       "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
        strokeWidth:"0.4",
        fill: props.dark ? "white" : "black"
       },
       // change all labels fontFamily shown on both xAxis and yAxis
       "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{
           fontFamily: "Roboto",
        },
        // change bottom label styles
        "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel":{
            strokeWidth:"0.5",
            fill: props.dark ? "white" : "black"
         },
          // bottomAxis Line Styles
         "& .MuiChartsAxis-bottom .MuiChartsAxis-line":{
          stroke: props.dark ? "white" : "black",
          strokeWidth:0.4
         },
         // leftAxis Line Styles
         "& .MuiChartsAxis-left .MuiChartsAxis-line":{
          stroke: props.dark ? "white" : "black",
          strokeWidth:0.4
         }
      }}
      
      width={700}
      height={300}
    />
                    </div>
    )
}

export default Stats;